import React from 'react';
import { IPotentialMatch } from './IPotentialMatch';
import { eIncomingFundsType } from './eIncomingFundsType';
import { ConfirmWireMatch } from './ConfirmWireMatch';
import { ConfirmCheckMatch } from './ConfirmCheckMatch';
import { ConfirmACHMatch } from './ConfirmACHMatch';

export interface IConfirmMatchProps {
  actualId: string;
  accountNumber: string;
  type: eIncomingFundsType;
  potentialMatch: IPotentialMatch;
  onClose: () => void;
  amountCents: number;
  amountCentsMax: number;
}

export const ConfirmMatch: React.FC<IConfirmMatchProps> = ({
  actualId,
  accountNumber,
  type,
  potentialMatch,
  onClose,
  amountCents,
  amountCentsMax,
}) => {
  return (
    <div className={'py-4'}>
      {type === 'wire' && (
        <ConfirmWireMatch
          actualId={actualId}
          accountNumber={accountNumber}
          potentialMatch={potentialMatch}
          onClose={onClose}
          amountCents={amountCents}
          amountCentsMax={amountCentsMax}
        />
      )}
      {type === 'check' && (
        <ConfirmCheckMatch
          actualId={actualId}
          accountNumber={accountNumber}
          potentialMatch={potentialMatch}
          onClose={onClose}
          amountCents={amountCents}
          amountCentsMax={amountCentsMax}
        />
      )}
      {type === 'ach' && (
        <ConfirmACHMatch
          actualId={actualId}
          accountNumber={accountNumber}
          potentialMatch={potentialMatch}
          onClose={onClose}
          amountCents={amountCents}
          amountCentsMax={amountCentsMax}
        />
      )}
    </div>
  );
};
